import API from './ApiBase';

export const getBillingPortal = async (returnUrl?: string) => {
  const response = await API.get<{ url: string }>('/billing/billing-portal', {
    params: { returnUrl },
  });
  return response;
};
